import { useState, useEffect, useRef } from 'react';
import {
  useListController,
  ListContextProvider,
  Datagrid,
  TextField,
  NumberField,
  Pagination,
  Loading,
  ShowButton,
  FunctionField,
  EditButton,
} from 'react-admin';
import debounce from 'lodash/debounce';

export const SearchableUserList = () => {
  // Initialize the list controller without any filters
  const controllerProps = useListController({
    resource: 'users',
    perPage: 10,
    sort: { field: 'email', order: 'ASC' },
    filter: {},    // start with no filters
  });
  const { isLoading, setFilters } = controllerProps;

  // Local state for the search input
  const [search, setSearch] = useState('');

  // stable debounced filter setter
  const applySearch = useRef(
    debounce((value: string) => {
      if (value.trim().length >= 3) {
        setFilters({ q: value }, { q: true });
      } else if (value.trim().length === 0) {
        setFilters({}, {});
      }
    }, 300)
  ).current;

  const isFirstMount = useRef(true);

  // Whenever `search` changes, call the debounced function
  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }
    applySearch(search);
  }, [search, applySearch]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <ListContextProvider value={controllerProps}>
      <div style={{ marginBottom: '1em' }}>
        <input
          type="text"
          placeholder="Search by Email (min 3 chars)…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '200px', padding: '0.5em' }}
        />
      </div>

      <Datagrid>
        <TextField source="email" />
        <TextField source="display_name" />
        <FunctionField
          label="Created"
          sortBy="created_time"
          render={record => {
            const ts = record.created_time;
            const date = ts?.toDate ? ts.toDate() : new Date(ts);
            return date instanceof Date && !isNaN(date.getTime())
              ? date.toLocaleString()
              : '';
          }}
        />
        <NumberField source="total_referred_active_users" />
        <NumberField source="lifetime_usd_earnings" />
        <NumberField source="lifetime_ads_watched" />
        <NumberField source="lifetime_tokens_earned" />
        <NumberField source="redeemable_tokens" />
        <NumberField source="balance_usd" />
        <ShowButton />
        <EditButton />
      </Datagrid>
      <Pagination />
    </ListContextProvider>
  );
};